import { useEffect } from 'react'

// Rakuten's browser extension injects a banner outside our react tree
export const useRemoveRakutenBanner = () => {
  useEffect(() => {
    let timeoutId: ReturnType<typeof setTimeout> | undefined
    let tries = 0
    const totalTimeToTryToRemove = 5000 // 5 seconds
    const timer = 50 // ms
    const maxTries = totalTimeToTryToRemove / timer

    function removeBanner() {
      timeoutId = setTimeout(function () {
        tries++
        const element = document.querySelector('div[style="all: initial !important;"]')

        if (element) {
          element.remove()
          tries = maxTries + 1
        }

        if (tries < maxTries) {
          removeBanner()
        }
      }, timer)
    }

    removeBanner()

    return () => clearTimeout(timeoutId)
  }, [])
}
